import React, { useEffect } from 'react'
import styles from 'modules/User/Settings/Settings.module.scss'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import { Typography } from 'gu-ui-kit'
import Security from 'modules/User/Security'
import Profile from 'modules/User/Profile'
import Accounts from 'modules/User/Accounts'
import { useDispatch } from 'react-redux'
import { GET_USER_INFO, RESET_USER_INFO } from 'modules/User/Profile/types'
import { GET_2FA, RESET_2FA } from 'modules/User/Security/2fa/types'
import PageHeader from 'components/PageHeader'

const UserSettings = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  useEffect(() => {
    dispatch({ type: GET_USER_INFO })
    dispatch({ type: GET_2FA })

    return () => {
      dispatch({ type: RESET_USER_INFO })
      dispatch({ type: RESET_2FA })
    }
  }, [])

  return (
    <div>
      <div className={styles['user-settings']}>
        <div className={'margin-bottom-40'}>
          <PageHeader className={'margin-bottom-16'}>
            {t('user::settings.profile.header')}
          </PageHeader>
          <Typography variant={'Body-20'} className={'margin-bottom-16'} color={'Label-Secondary'}>
            {t('user::settings.profile.description')}
          </Typography>
        </div>
        <div className={clsx(styles['user-settings__block'], 'margin-bottom-16')}>
          <Profile />
        </div>

        <div className={clsx(styles['user-settings__block'], 'margin-bottom-16')}>
          <Security />
        </div>

        <div className={clsx(styles['user-settings__block'], 'margin-bottom-16')}>
          <Accounts />
        </div>
      </div>
    </div>
  )
}

export default UserSettings
